import React from "react";
import PropTypes from "prop-types";
import GroupedEdges from "../components/evidence/GroupedEdges.js";
import {inject, observer} from "mobx-react";
import {renderMarkdownWithInterpolation} from "./markdown-factory";
import {TEMPLATE_CONSTANTS} from "./index";
import {EVC_NODE_DEFAULT} from "./evidence/templates";
import EntityView from "../components/EntityView";

const TYPE_NODE = "node";
const TYPE_EDGE = "multiedge";

const EChainMarkdownFactory  = ({
    data: {type, content: edges, entity, similarNeighbor},
    scaleFactor,
    actions,
    highlightedDatasets,
    edgeIndex,
    hasSimilarity,
    edgeSpan = 1,
    edgePosition = 'center',
    entityRef = null,
    searchSessionStore: { templates, datasets }
  }) => {
  if (type === TYPE_NODE) {
    if (!entity) {
      console.warn("No entity provided for node");
      return "";
    }
    return renderMarkdownWithInterpolation({
                                             templateType: TEMPLATE_CONSTANTS.EVIDENCE_CHAIN.NODE,
                                             templates,
                                             templateOverrides: {
                                               EvcNode: {
                                                 component: EntityView,
                                                 props: {
                                                   showLabel: true,
                                                   actions,
                                                   scale: scaleFactor,
                                                   dataset: datasets[entity.dataset],
                                                   similarNeighbor,
                                                   edgeIndex,
                                                   entityImageRef: entityRef},
                                               }
                                             },
                                             entity,
                                             fallback: EVC_NODE_DEFAULT,
                                           });
  }
  if (type === TYPE_EDGE) {
    const highlighted = new Set(highlightedDatasets);
    const hasHighlighted = edges.reduce((result, el) => result || highlighted.has(el.dataset), false);
    const filteredEdges = edges?.filter(el => !hasHighlighted || highlighted.has(el.dataset)) || [];

    // Create unique key based on edge content to ensure proper component reset across different chains
    const edgesKey = filteredEdges.map(e => `${e.dataset}:${e.dataPoints?.length || 0}:${e.dataPoints?.[0]?.title || ''}`).join('|');
    return (
      <GroupedEdges
        key={edgesKey}
        datasets={datasets}
        scaleFactor={scaleFactor}
        edges={filteredEdges}
        actions={actions}
        highlightedDatasets={highlightedDatasets}
        edgeIndex={edgeIndex}
        hasSimilarity={hasSimilarity}
        edgeSpan={edgeSpan}
        edgePosition={edgePosition}
      />
    );
  }
  return <span>unknown evidence chain fragment type</span>;
}

EChainMarkdownFactory.propTypes = {
  data: PropTypes.object,
  scaleFactor: PropTypes.string,
  actions: PropTypes.any,
  highlightedDatasets: PropTypes.arrayOf(PropTypes.string),
};

export default inject("searchSessionStore")(observer(EChainMarkdownFactory));
